import { toKebabCase } from '@websolutespa/bom-core';
import { renderInstance, observeIntersections, observeMutations, queryElements, renderEmbed } from './utils.js';

function getInitializer(globalName, plugins) {
  if (globalName === void 0) {
    globalName = 'bomLlm';
  }
  const initializer = props => {
    if (!document) {
      return;
    }
    const body = document.querySelector('body');
    if (!body) {
      return;
    }
    props.plugins = [...(props.plugins || []), ...(plugins || [])];
    const id = toKebabCase(globalName);
    const node = document.createElement('div');
    node.setAttribute('id', id);
    body.appendChild(node);
    const initError = 'llm plugin is not initialized';
    const llmInstance = {
      open: () => {
        console.log(initError);
      },
      setOpened: opened => {
        console.log(initError);
      },
      isOpened: () => {
        console.log(initError);
        return false;
      },
      send: message => {
        console.log(initError);
      },
      clear: () => {
        console.log(initError);
      },
      dispose: () => {
        console.log(initError);
      }
    };
    const threadId = new URLSearchParams(window.location.search).get('llmThreadId');
    if (!props.threadId && threadId) {
      props.threadId = threadId;
    }
    renderInstance(node, props, llmInstance);
    // observe embeds
    const onIntersection = node => {
      // console.log('onIntersection', node);
      renderEmbed(node, props);
    };
    const targetElement = document;
    const intersectionObserver = observeIntersections(targetElement, onIntersection);
    const embeds = Array.from(document.querySelectorAll('llm-embed')).filter(element => !element.hasAttribute('data-llm'));
    embeds.forEach(element => intersectionObserver.observe(element));
    const mutationObserver = observeMutations(targetElement, _ref => {
      let {
        addedNodes,
        removedNodes
      } = _ref;
      // console.log('addedNodes', addedNodes);
      const addedElements = Array.from(addedNodes).filter(x => x.nodeType === Node.ELEMENT_NODE);
      // console.log('addedElements', addedElements);
      const elements = queryElements(addedElements);
      // console.log('elements', elements);
      elements.forEach(element => intersectionObserver.observe(element));
    });
    const elements = queryElements(targetElement);
    elements.forEach(element => intersectionObserver.observe(element));
    const dispose = () => {
      intersectionObserver.disconnect();
      mutationObserver.disconnect();
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    };
    llmInstance.dispose = dispose;
    return llmInstance;
  };
  if (typeof window !== 'undefined') {
    window[globalName] = initializer;
  }
  return initializer;
}

export { getInitializer };
//# sourceMappingURL=initializer.js.map
